import { takeLatest, call, put } from 'redux-saga/effects'
import {
    addTaskAPI, assignTaskAPI, taskDetailAPI, taskListAPI, updateTaskDetailAPI,
    updateTaskStatusAPI, addTaskCommentAPI
} from '../api-requests/task';
import {
    addTaskRequestError, addTaskRequestSuccess, assignTaskRequestError, assignTaskRequestSuccess,
    taskDetailRequestError, taskDetailRequestSuccess, taskListRequestError, taskListRequestSuccess,
    updateTaskDetailRequestError, updateTaskDetailRequestSuccess, updateTaskStatusRequestError,
    updateTaskStatusRequestSuccess, addTaskCommentRequestError, addTaskCommentRequestSuccess
} from './task.action';
import { TaskActionTypes } from './task.types'
import { displayConsoleLog } from '../../utils/Utils'
import { decryptResponseData } from '../../utils/DataDecryptionUtils';

function* handleAddTaskComment({ payload }) {
    try {
        const response = yield call(addTaskCommentAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(addTaskCommentRequestSuccess(decryptedData))
            } else {
                yield put(addTaskCommentRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error.response.data)
        yield put(addTaskCommentRequestError(error.response.data))
    }
}

export function* addTaskCommentReq() {
    yield takeLatest(TaskActionTypes.ADD_TASK_COMMENT_REQUEST, handleAddTaskComment)
}

function* handleUpdateTaskStatus({ payload }) {
    try {
        const response = yield call(updateTaskStatusAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(updateTaskStatusRequestSuccess(decryptedData))
            } else {
                yield put(updateTaskStatusRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error.response.data)
        yield put(updateTaskStatusRequestError(error.response.data))
    }
}

export function* updateTaskStatusReq() {
    yield takeLatest(TaskActionTypes.UPDATE_TASK_STATUS_REQUEST, handleUpdateTaskStatus)
}

function* handleUpdateTaskDetail({ payload }) {
    try {
        const response = yield call(updateTaskDetailAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(updateTaskDetailRequestSuccess(decryptedData))
            } else {
                yield put(updateTaskDetailRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error.response.data)
        yield put(updateTaskDetailRequestError(error.response.data))
    }
}

export function* updateTaskDetailReq() {
    yield takeLatest(TaskActionTypes.UPDATE_TASK_DETAIL_REQUEST, handleUpdateTaskDetail)
}

function* handleTaskList({ payload }) {
    try {
        const response = yield call(taskListAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(taskListRequestSuccess(decryptedData))
            } else {
                yield put(taskListRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error.response.data)
        yield put(taskListRequestError(error.response.data))
    }
}

export function* taskListReq() {
    yield takeLatest(TaskActionTypes.TASK_LIST_REQUEST, handleTaskList)
}

function* handleTaskDetail({ payload }) {
    try {
        const response = yield call(taskDetailAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(taskDetailRequestSuccess(decryptedData))
            } else {
                yield put(taskDetailRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error.response.data)
        yield put(taskDetailRequestError(error.response.data))
    }
}

export function* taskDetailReq() {
    yield takeLatest(TaskActionTypes.TASK_DETAIL_REQUEST, handleTaskDetail)
}

function* handleAssignTask({ payload }) {
    try {
        const response = yield call(assignTaskAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(assignTaskRequestSuccess(decryptedData))
            } else {
                yield put(assignTaskRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error.response.data)
        yield put(assignTaskRequestError(error.response.data))
    }
}

export function* assignTaskReq() {
    yield takeLatest(TaskActionTypes.ASSIGN_TASK_REQUEST, handleAssignTask)
}

function* handleAddTask({ payload }) {
    try {
        const response = yield call(addTaskAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(addTaskRequestSuccess(decryptedData))
            } else {
                yield put(addTaskRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error.response.data)
        yield put(addTaskRequestError(error.response.data))
    }
}

export function* addTaskReq() {
    yield takeLatest(TaskActionTypes.ADD_TASK_REQUEST, handleAddTask)
}